export default __webpack_public_path__ + "assets/0450f246782b2a4494008716e20785fb.jpg";